/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface SalesAffiliationInfoVO {
  /**
   * account number
   */
  accountNumber?: string;
  affiliationType?: SalesAffiliationInfoVO.AffiliationTypeEnum;
  /**
   * id
   */
  id?: string;
  /**
   * Save Corporate Program indicator
   */
  saveCorporateProgram?: boolean;
}
export namespace SalesAffiliationInfoVO {
  export type AffiliationTypeEnum = 'SKYB' | 'BBIZ' | 'CRAM' | 'CRG3' | 'DPJN';
  export const AffiliationTypeEnum = {
    SKYB: 'SKYB' as AffiliationTypeEnum,
    BBIZ: 'BBIZ' as AffiliationTypeEnum,
    CRAM: 'CRAM' as AffiliationTypeEnum,
    CRG3: 'CRG3' as AffiliationTypeEnum,
    DPJN: 'DPJN' as AffiliationTypeEnum
  };
}
